export default __webpack_public_path__ + "3fcb75a862dab7eab72ad475f7480344.wasm";